var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.optimizerManagerCreatePermission)?_c('div',{attrs:{"id":"page-user-edit"}},[_c('vx-card',[_c('optimizer-manager-tab-account',{staticClass:"mt-4",attrs:{"data":{}}})],1)],1):_c('not-permission')
}
var staticRenderFns = []

export { render, staticRenderFns }